import { Title } from "@/components/common/typography/Title";
import whyus from "@/assets/images/pricing/whyus.webp";
import Image from "next/image";

export const WhyUs = () => {
  return (
    <section className="relative flex flex-col gap-12 px-4 py-20 ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <Title
        text="POURQUOI NOUS"
        position="left"
        color="secondary"
        className="hidden ph:flex"
      />
      <Title
        text={["POURQUOI", "NOUS"]}
        position="left"
        color="secondary"
        textPosition="left"
        className="flex ph:hidden"
      />

      <div className="flex flex-col items-center gap-8 text-white lg:flex-row">
        <div className="flex flex-col gap-6 lg:w-1/2">
          <p className="text-lg">
            Découvrez un club de Taekwondo où technique, self-défense et combat
            sont au cœur de l&apos;apprentissage.
          </p>

          <p className="text-lg">
            Affilié à la Fédération Française de Taekwondo (FFTDA) et reconnu
            par la mairie d&apos;Argenteuil (Val d&apos;Oise), notre club vous
            garantit un cadre structuré et officiel.
          </p>

          <div className="mt-4">
            <p className="mb-4 text-lg font-semibold">Rejoignez-nous pour :</p>
            <ul className="list-disc space-y-2 pl-6">
              <li>Valider vos grades de ceinture.</li>
              <li>
                Participer à des stages et compétitions (combat, self-défense,
                technique).
              </li>
            </ul>
          </div>

          <p className="text-lg">
            Notre club, convivial et familial, est animé par un maître ceinture
            noire 6ème Dan, instructeur international et juge technique. Sa
            passion et son expertise sauront vous inspirer.
          </p>

          <p className="text-lg">
            Labellisé QUALITÉ 3 étoiles par la fédération, nous offrons une
            expérience d&apos;excellence.
          </p>

          <p className="text-lg">
            Situé en plein centre-ville d&apos;Argenteuil, dans un grand gymnase
            moderne, nous vous accueillons pour pratiquer dans les meilleures
            conditions.
          </p>
        </div>

        <div className="lg:w-1/2">
          <Image
            src={whyus}
            loading="lazy"
            alt="Démonstration de Taekwondo"
            className="h-auto w-full rounded-lg object-cover"
          />
        </div>
      </div>
    </section>
  );
};
